import React from 'react';
import { useRecordContext } from 'react-admin';
import Chip from '@mui/material/Chip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HelpIcon from '@mui/icons-material/Help';

const PeppolStatusField = () => {
    const record = useRecordContext();

    if (!record) return null;

    // Determine status and icon
    if (record.is_present_on_peppol === true) {
        return (
            <Chip
                icon={<CheckCircleIcon />}
                label="On PEPPOL"
                color="success"
                variant="outlined"
                size="small"
            />
        );
    } else if (record.is_present_on_peppol === false) {
        return (
            <Chip
                icon={<CancelIcon />}
                label="Not on PEPPOL"
                color="warning"
                variant="outlined"
                size="small"
            />
        );
    } else {
        return (
            <Chip
                icon={<HelpIcon />}
                label="Not checked"
                color="default"
                variant="outlined"
                size="small"
            />
        );
    }
};

export default PeppolStatusField;
